import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, Input, OnInit } from '@angular/core';
import { HiringService } from 'src/app/pages/hiring/services/hiring.service';
import { EmployeeService } from 'src/app/pages/employee/services/employee.service';
import { UtilityService } from '../../../core/services/utility.service';
import { HttpClient, HttpRequest, HttpEvent, HttpEventType } from '@angular/common/http';
import { FieldService } from 'src/app/pages/field/service/field.service';

@Component({
  selector: 'app-add-attachment-modal',
  templateUrl: './add-attachment-modal.component.html',
  styleUrls: ['./add-attachment-modal.component.css']
})
export class AddAttachmentModalComponent implements OnInit {
  @Input() itemID: any;
  @Input() moduleID: number;
  @Input() active: boolean;
  @Input() status: any;
  @Input() mobileMode: boolean;
  @Input() allowMultipleAttachments: boolean;
  formData: { [key: string]: any } = {};
  newFiles: any[] = [];
  savedFiles: any[] = [];
  fileData: any[] = [];
  alert: any;
  errorMsg: any;
  captionChanged: boolean = false;
  validComboDrag: boolean = false;
  dragFiles: any;
  isSendToVista: boolean = false;

  constructor(public activeModal: NgbActiveModal, private hiringService: HiringService, private employeeService: EmployeeService, private utilityService: UtilityService, public HttpClient: HttpClient, private fieldService: FieldService) {
  }

  ngOnInit(): void {
    this.isSendToVista = this.moduleID == 105 || this.moduleID == 115;
    if(!this.isSendToVista){
      this.getAttachmentList();
    }
  }

  getAttachmentList() {
    var requestParam = "moduleID=" + this.moduleID + "&recordID=" + this.itemID;
    this.employeeService.getFileAttachmentList(requestParam).then((response: any) => {
      this.savedFiles = response;
      this.savedFiles.forEach((val: any) => {
        if (val.AttachmentCaption != null)
          val.TempAttachmentCaption = val.AttachmentCaption;
      });
    })
  }


  deleteUnsavedAttachment(file: any) {
    var index = this.newFiles.indexOf(file);
    this.newFiles.splice(index, 1);
  }

  deleteSavedAttachment(file: any) {
    this.employeeService.removeFileAttachment(file.FileAttachmentID).then((response: any) => {
      if (response.success) {
        this.captionChanged = false;
        if (this.moduleID == 12) {
          this.employeeService.updateOnboardTaskComplete(this.itemID).then((response: any) => {
            if (response.success) {
            }
          });
        }
        this.getAttachmentList();
      }
    })
  }

  upload() {
    var currentUpload = this.formData.fileDrop;
    this.formData.fileDrop = [];
    for (var i = 0; i < currentUpload.length; i++) {
      this.fileUpload(currentUpload[i]);
    }
    if (this.mobileMode) {
      setTimeout(() => {
        if (this.newFiles.length > 0) {
          $("#fileDrop").css("cursor", "no-drop");
        }
      }, 200);
    }
  }

  fileUpload(fileDrop) {
    this.fileData = [];
    if (fileDrop != null) {
      fileDrop.nameEdit = "";
      for (var y = 0; y < fileDrop.name.substr(0, fileDrop.name.lastIndexOf('.') + 1).length; y++) {
        if (fileDrop.name[y] != " " && fileDrop.name[y] != "&" && fileDrop.name[y] != "*" && fileDrop.name[y] != ":" &&
          fileDrop.name[y] != ";" && fileDrop.name[y] != "|" && fileDrop.name[y] != "=" && fileDrop.name[y] != "," &&
          fileDrop.name[y] != "." && fileDrop.name[y] != "/" && fileDrop.name[y] != "\"" && fileDrop.name[y] != "[" &&
          fileDrop.name[y] != "]")
          fileDrop.nameEdit += fileDrop.name[y];
      }
      fileDrop.nameEdit += fileDrop.name.substr(fileDrop.name.lastIndexOf('.'), fileDrop.name.length);
      this.readFile(fileDrop, (e: any, fileName: string) => {
        setTimeout(() => {
          this.fileData.push({ data: e.target.result.toString().split(","), size: e.total, name: fileName })
          this.fileData.forEach((val: any) => {
            if ((fileDrop.size == val.size && val.name == fileDrop.name) && ((this.moduleID == 38 && this.newFiles.length < 2 && (this.newFiles.length + this.savedFiles.length < 2)) || this.moduleID != 38)) {
              this.newFiles.push({ File: val.data[1], Filename: fileDrop.nameEdit, Filedata: fileDrop, Type: val.data[0].split("/")[0] });
            }
          });
        });
      });
    }
  }

  checkCaption() {
    this.captionChanged = false;
    this.savedFiles.forEach((val: any) => {
      if (val.TempAttachmentCaption != val.AttachmentCaption) {
        this.captionChanged = true;
        this.formData.disableButton = false;
      }
    });
  }

  private readFile(file: any, call: any) {
    var reader = new FileReader();
    reader.onload = function (e) { return call(e, file.name) };
    reader.readAsDataURL(file);
  }

  uploadAttachment(counter, error) {
    var currentFile = this.newFiles[counter];
    var type = "file";
    var errMsg;
    var data;
    var url;
    if (currentFile.Type == "data:image")
      type = "Photo";
    if (currentFile.Progress != 100) {
      if (currentFile.File != null && currentFile.Filename != null) {
        var temp = currentFile.Type;
        var type = "file";
        if (temp == "data:image")
          type = "Photo";
        if (this.isSendToVista) {
          url = "/Field/AddVPAttachment";
          data = {
            fileName: currentFile.Filename, fileDescription: "", fileData: currentFile.File,
            moduleID: this.moduleID, recordKeyID: this.itemID, fileAttachmentID: -1, fileAttachmentType: type
          }
        }
        else {
          url = "/Employee/SaveFileAttachment";
          data = { 
            moduleID: this.moduleID, recordID: this.itemID, attachmentFileData: currentFile.File, 
            attachmentFileName: currentFile.Filename, attachmentType: type 
          }
        }
        currentFile.Filedata.upload = new HttpRequest(
          "POST",
          url,
          data, 
          { reportProgress: true }
        ),
          currentFile.Filedata.upload = this.HttpClient.request(currentFile.Filedata.upload).subscribe((event: HttpEvent<any>) => {
            switch (event.type) {
              case HttpEventType.UploadProgress:
                currentFile.Progress = Math.round(event.loaded / event.total * 100);
                if (currentFile.Progress == 100) {
                  currentFile.AttchDone = true;
                }
                break;
              case HttpEventType.Response:
                setTimeout(() => {
                  currentFile.Filedata.result = event.body;
                });
                if (event.body.success) {
                  counter++;
                  if(this.isSendToVista){
                    this.addBillAttachment(event.body.data, counter, error);
                  }
                  if (counter < this.newFiles.length) {
                    this.uploadAttachment(counter, error);
                  }
                  if (counter == this.newFiles.length) {
                    this.formData.disableButton = false;
                    if (error == 0) {
                      this.newFiles = [];
                      if (this.captionChanged) {
                        this.savedFiles.forEach((val: any, key: any) => {
                          if (val.AttachmentCaption != val.TempAttachmentCaption) {
                            this.hiringService.fileAttachmentUpdateCaption(val.FileAttachmentID, val.AttachmentCaption).then((response: any) => {
                              this.utilityService.fadeLabel(response.success);
                              val.TempAttachmentCaption = val.AttachmentCaption;
                              this.captionChanged = false;
                            });
                          }
                          if (key == this.savedFiles.length - 1)
                            this.getAttachmentList();
                        });
                      } else if(!this.isSendToVista)
                        this.getAttachmentList();
                    } else {
                      this.alert = { type: "danger", msg: errMsg + " failed to save one or more attachments - " };
                    }
                  }
                }
                else {
                  error++; counter++;
                  errMsg += currentFile.Filename + ",";
                  if (counter < this.newFiles.length){
                    this.uploadAttachment(counter, error);
                  }
                  else if (this.isSendToVista){
                    this.activeModal.close(error);
                  }
                }
            }
            error => this.errorMsg = error.message
          })
      }
    }
  }

  addBillAttachment(attachmentDetail: any, counter: number, error: number){
    this.fieldService.addBillAttachment(this.itemID, attachmentDetail.AttachmentID).then((response:any)=>{
      if(response != null && !response.success){
        this.alert = { type: "danger", msg: " failed to save one or more attachments - " };
      }
    });
    if(counter == this.newFiles.length){
      this.activeModal.close(error);
    }
  }

  saveClicked() {
    this.formData.disableButton = true;
    if (this.newFiles.length > 0) {
      this.uploadAttachment(0, 0);
    } else {
      if (this.captionChanged) {
        this.savedFiles.forEach((val: any) => {
          if (val.AttachmentCaption != val.TempAttachmentCaption) {
            this.hiringService.fileAttachmentUpdateCaption(val.FileAttachmentID, val.AttachmentCaption).then((response: any) => {
              this.utilityService.fadeLabel(response.success);
              val.TempAttachmentCaption = val.AttachmentCaption;
              this.captionChanged = false;
              this.formData.disableButton = false;
            });
          }
        });
      }
    }
  }

  closeClicked() {
    this.activeModal.close("close");
  }

  closeAlert() {
    this.alert = null;
  }


}